import campusApi from './modules/campusApi.js'
import approvalApi from './modules/approvalApi.js'
import classApi from './modules/classApi.js'
import classRoomApi from './modules/classRoomApi.js'
import gradeApi from './modules/gradeApi.js'
import permissionApi from './modules/permissionApi.js'
import roleApi from './modules/roleApi.js'
import scholarshipApi from './modules/scholarshipApi.js'
import studentApi from './modules/studentApi.js'
import subjectApi from './modules/subjectApi.js'
import timetableApi from './modules/timetableApi.js'
import userApi from './modules/userApi.js'
import weekApi from './modules/weekApi.js'
import quizApi from './modules/quizApi.js'
import statisticsApi from './modules/statisticsApi.js'

const api = {
  ...campusApi,
  ...classApi,
  ...classRoomApi,
  ...gradeApi,
  ...permissionApi,
  ...quizApi,
  ...roleApi,
  ...scholarshipApi,
  ...studentApi,
  ...subjectApi,
  ...timetableApi,
  ...userApi,
  ...weekApi,
  ...approvalApi,
  ...statisticsApi,
  LOGIN: 'CSVPA-China/api/login/login' //登录
}

export default api
